<template>
  <div class="font-rubik h-full flex flex-col justify-between pl-6 pt-10 pb-auto">
    <div>
      <h2 class="dropdown-name mb-5">{{ currentDropdown.name.toUpperCase() }}</h2>
      <ul>
        <li v-for="(link, index) in currentDropdown.links" :key="index">
          <a class="dropdown-link flex items-center mb-3 transition-all" :href="link.slug">
            <span class="dropdown-link-name" :class="{ 'always-blue': link.slug === '/service-areas' }">
              {{ link.title }}
            </span>
            <img class="h-4 ml-1" src="@/images/service-area-cards/arrow-outward.svg" alt="Arrow">
          </a>
        </li>
      </ul>
    </div>
    <div v-if="showSeeAllLink" class="flex items-center gap-2 mb-2">
      <a class="see-all-link" :href="showSeeAllLink.slug">See All</a>
      <img src="@/images/header/chevron-right.svg" alt="See all links">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeDropdown: String,
    dropdownLinks: Object
  },
  computed: {
    currentDropdown() {
      return this.dropdownLinks[this.activeDropdown]
    },
    showSeeAllLink() {
      return this.currentDropdown.seeAll
    }
  }
}
</script>

<style scoped>
.dropdown-name {
  font-size: 14px;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: 0.02em;
  color: #334155;
}

.dropdown-link {
  transition: background-color 0.3s ease, transform 0.3s ease; 
}

.dropdown-link-name {
  font-size: 14px;
  font-weight: 400;
  line-height: 10px;
  color: #334155 !important;
}
.dropdown-link-name:hover {
  color: #1049FB !important;
}

.always-blue {
  color: #1049FB !important;
}

.dropdown-link img {
  padding: 2px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 50%;
}

.dropdown-link:hover img {
  padding: 2px;
  background-color: white;
  transform: rotate(45deg);
  box-shadow: 0 0 0 1px white;
  border: 1px solid #334155;
}

.see-all-link {
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: -0.04em;
  color: #334155 !important;
}
</style>
